import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {
        suppliesAndWarehouseMoves: [],
    },
    mutations: {
        setSuppliesAndWarehouseMoves(state, data) {
            state.suppliesAndWarehouseMoves = data;
        },
        addSupply(state, supplyData) {
            state.suppliesAndWarehouseMoves.unshift(supplyData);
        },
        addWarehouseMove(state, warehouseMoveData) {
            state.suppliesAndWarehouseMoves.unshift(warehouseMoveData);
        },
    },
    actions: {
        async getSuppliesAndWarehouseMoves({commit, rootState}) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.WAREHOUSE_MOVE_AND_SUPPLY.WAREHOUSE_MOVES_AND_SUPPLIES_URL;
            const options = {
                method: "GET",
                credentials: "include",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
            };
            const successfulHandler = (data) => {
                commit("setSuppliesAndWarehouseMoves", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createSupply({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {description, warehouse_id, goods_data, currency} = params;
            const url = URLS.MODEL.SUPPLY.SUPPLIES_URL;
            const options = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    description: description,
                    warehouse_id: warehouse_id,
                    goods_data: goods_data,
                    currency: currency,
                }),
            };
            const successfulHandler = (data) => {
                commit("addSupply", data.data);
                commit("good/increaseGoodsAmount", data.data, {root: true});
                notify(i18n.global.t("Supply successfully added"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createWarehouseMove({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {description, warehouse_from, warehouse_to, goods_data, is_write_off} = params;
            const url = URLS.MODEL.WAREHOUSE_MOVE.WAREHOUSE_MOVES_URL;
            const options = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    description: description,
                    warehouse_from: warehouse_from,
                    warehouse_to: warehouse_to,
                    goods_data: goods_data,
                    is_write_off: is_write_off,
                }),
            };
            const successfulHandler = (data) => {
                commit("addWarehouseMove", data.data);
                commit("good/updateGoodsAmount", data.data, {root: true});
                notify(i18n.global.t("Stock transfer completed successfully"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};